import { FC } from "react";
import { useFetcher, useNavigate } from "react-router";
import { Text } from "@postenbring/hedwig-react";
import Translated from "../infrastructure/translation/Translated";
import { CenteredSpinner } from "../CenteredSpinner/CenteredSpinner";
import { ClientForm } from "./ClientForm";
import styles from "./NewClientPage.module.css";
import {
  useAvailableAccounts,
  useClientCertificateOptions,
} from "./clientsRouteContext";
import { useClientForm } from "./useClientForm";
import { useClientPaths } from "./useClientPaths";

export const NewClientPage: FC = () => {
  const navigate = useNavigate();
  const paths = useClientPaths();

  const fetcher = useFetcher();
  const availableAccounts = useAvailableAccounts();
  const { certificates } = useClientCertificateOptions();

  const form = useClientForm({
    selectableCertificateIds: certificates.map((c) => c.certificate.id),
    missingEndpointTextKey: "new_client.error_no_endpoint",
    fetcher,
  });

  if (form.submitting) {
    return (
      <div className={styles.container}>
        <CenteredSpinner />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Text variant="h1" as="h1" size="min" className={styles.title}>
        <Translated textKey={"new_client.header"} />
      </Text>
      <Text variant="body-small" className={styles.intro}>
        <Translated textKey={"new_client.description"} />
      </Text>

      <ClientForm
        form={form}
        availableAccounts={availableAccounts}
        submitTextKey="new_client.submit"
        onCancel={() => navigate(`${paths.organization}/clients`)}
        certificates={certificates}
      />
    </div>
  );
};
